__webpack_require__.p = "/static/store/template_2/";